module.exports = __webpack_public_path__ + "static/digital_technology_services-91a0620a0b3bc6d89c90d62faedb531f.jpg";